var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 109,
    viewBox: "0 0 100 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2507 33.7452C48.952 32.7516 51.0481 32.7516 52.7493 33.7452L67.2508 42.2142C68.952 43.2078 70 45.044 70 47.0311V63.969C70 65.9562 68.952 67.7924 67.2508 68.7859L52.7493 77.2548C51.0481 78.2484 48.952 78.2484 47.2507 77.2548L32.7493 68.7859C31.048 67.7924 30 65.9562 30 63.969V47.0311C30 45.044 31.048 43.2078 32.7493 42.2142L47.2507 33.7452Z",
    fill: "#CCFF00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_715_1203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5644 46.5952C40.275 46.0928 40.4468 45.4507 40.9481 45.1607L48.6365 40.7141C49.1379 40.4241 49.7791 40.5962 50.0686 41.0985C50.358 41.6008 50.1863 42.243 49.6849 42.533L41.9964 46.9795C41.4951 47.2695 40.854 47.0974 40.5644 46.5952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9415 55.206C40.6519 54.7038 40.8237 54.0615 41.3252 53.7716L44.138 52.1448C44.6393 51.8547 45.2805 52.0269 45.5699 52.5292C45.8594 53.0314 45.6876 53.6737 45.1863 53.9637L42.3735 55.5904C41.8721 55.8805 41.2309 55.7084 40.9415 55.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5019 49.5293C50.2125 49.027 50.3843 48.3847 50.8856 48.0948L55.1742 45.6146C55.6756 45.3245 56.3168 45.4966 56.6062 45.9989C56.8957 46.5012 56.7239 47.1435 56.2225 47.4334L51.934 49.9136C51.4326 50.2037 50.7915 50.0315 50.5019 49.5293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4082 41.8543C55.6978 41.3521 56.3388 41.18 56.8403 41.47L59.4957 43.0057C59.997 43.2957 60.1688 43.9379 59.8794 44.4402C59.5898 44.9424 58.9487 45.1147 58.4473 44.8246L55.792 43.2888C55.2905 42.9989 55.1187 42.3566 55.4082 41.8543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0312 45.9715C55.3207 45.4693 55.9619 45.2972 56.4632 45.5871L59.5022 47.3448C60.0036 47.6347 60.1755 48.277 59.8859 48.7793C59.5965 49.2815 58.9553 49.4536 58.4539 49.1636L55.4149 47.4061C54.9136 47.116 54.7418 46.4738 55.0312 45.9715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7929 65.2938C44.0825 64.7915 44.7236 64.6194 45.2251 64.9094L48.4763 66.7898C48.9776 67.0797 49.1495 67.7221 48.86 68.2243C48.5704 68.7265 47.9294 68.8986 47.4279 68.6086L44.1768 66.7284C43.6753 66.4383 43.5035 65.7961 43.7929 65.2938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5644 51.3754C40.275 50.8732 40.4468 50.2308 40.9481 49.9409L55.6252 41.4524C56.1267 41.1624 56.7677 41.3345 57.0573 41.8367C57.3467 42.339 57.1749 42.9813 56.6736 43.2713L41.9964 51.7597C41.4951 52.0497 40.854 51.8776 40.5644 51.3754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4443 45.0127C42.03 45.0127 42.5048 45.4883 42.5048 46.0749V50.7836C42.5048 51.3702 42.03 51.8458 41.4443 51.8458C40.8586 51.8458 40.3838 51.3702 40.3838 50.7836V46.0749C40.3838 45.4883 40.8586 45.0127 41.4443 45.0127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5525 49.5488C49.1383 49.5488 49.6131 50.0245 49.6131 50.6111V64.2777C49.6131 64.8643 49.1383 65.3399 48.5525 65.3399C47.9669 65.3399 47.4922 64.8643 47.4922 64.2777V50.6111C47.4922 50.0245 47.9669 49.5488 48.5525 49.5488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7117 52.0752C45.2975 52.0752 45.7723 52.5508 45.7723 53.1375V65.7129C45.7723 66.2996 45.2975 66.7752 44.7117 66.7752C44.1261 66.7752 43.6514 66.2996 43.6514 65.7129V53.1375C43.6514 52.5508 44.1261 52.0752 44.7117 52.0752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3072 51.9033C52.8771 51.9033 53.3391 52.366 53.3391 52.9368V66.144C53.3391 66.7147 52.8771 67.1775 52.3072 67.1775C51.7374 67.1775 51.2754 66.7147 51.2754 66.144V52.9368C51.2754 52.366 51.7374 51.9033 52.3072 51.9033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9853 43.0029C59.5709 43.0029 60.0457 43.4785 60.0457 44.0652V48.257C60.0457 48.8437 59.5709 49.3194 58.9853 49.3194C58.3996 49.3194 57.9248 48.8437 57.9248 48.257V44.0652C57.9248 43.4785 58.3996 43.0029 58.9853 43.0029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5088 53.4171C51.2193 52.9147 51.3911 52.2725 51.8924 51.9825L54.8911 50.2483C55.3925 49.9583 56.0336 50.1304 56.3232 50.6326C56.6127 51.135 56.4409 51.7772 55.9395 52.0671L52.9409 53.8014C52.4394 54.0914 51.7983 53.9193 51.5088 53.4171Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_715_1203",
    x: 0.383789,
    y: 0.573242,
    width: 99.6621,
    height: 108.176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_1203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_1203",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.67d314d185bd8ac32e3b20fa70496bbb.svg";
export { ForwardRef as ReactComponent };